module.exports = __webpack_public_path__ + "img/ios-download.9f1f8af6.png";